export const SET_USER = 'SET_USER'
export const SET_TEMP_LOGOS = 'SET_TEMP_LOGOS'
export const SET_AMOUNT = 'SET_AMOUNT'
export const SET_LOGOS = 'SET_LOGOS'
export const SET_CURRENT_LOGO = 'SET_CURRENT_LOGO'
export const SET_PREVIOUS_LOGO = 'SET_PREVIOUS_LOGO'
export const SET_OPTIONS = 'SET_OPTIONS'
export const INCREASE_ANSWER_COUNT = 'INCREASE_ANSWER_COUNT'
export const SET_ANSWER_COUNT = 'SET_ANSWER_COUNT'
export const START_GAME = 'START_GAME'
export const FINISH_GAME = 'FINISH_GAME'
export const TOGGLE_SOUND = 'TOGGLE_SOUND'
export const SET_HIGH_SCORES = 'SET_HIGH_SCORES'
export const SET_FIREBASE_FEEDBACK = 'SET_FIREBASE_FEEDBACK'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js